import { useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';

import { isPostHogEnabled } from '@/lib/posthog';
import { capturePostHogPageview } from '@/lib/posthog-pageview';

export function PostHogPageviewTracker() {
    const router = useRouter();

    useEffect(() => {
        if (!isPostHogEnabled()) {
            return;
        }

        const capture = () => {
            const location = router.state.resolvedLocation ?? router.state.location;
            const search = location.searchStr ?? '';
            capturePostHogPageview(location.pathname, search, document.title);
        };

        capture();

        return router.subscribe('onResolved', () => {
            capture();
        });
    }, [router]);

    return null;
}
